import { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

export default function SupportTicketsManager() {
  const [tickets, setTickets] = useState([]);
  const [error, setError] = useState("");

  async function load() {
    const data = await api("/api/admin/support-tickets");
    setTickets(data);
  }

  useEffect(() => {
    load().catch((err) => setError(err.message));
  }, []);

  async function updateStatus(id, status) {
    await api(`/api/admin/support-tickets/${id}/status`, {
      method: "PUT",
      body: JSON.stringify({ status }),
    });
    await load();
  }

  return (
    <AdminLayout title="Support Tickets">
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <div className="grid gap-4">
          {tickets.map((ticket) => (
            <div key={ticket.id} className="rounded-2xl border border-slate-200 p-4">
              <div className="flex flex-wrap justify-between gap-3">
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-emerald-700">{ticket.ticket_number}</p>
                  <h3 className="text-lg font-bold text-slate-900">{ticket.subject}</h3>
                  <p className="text-sm text-slate-500">{ticket.full_name} • {ticket.category} • {ticket.status}</p>
                  <p className="mt-2 text-sm text-slate-700">{ticket.message}</p>
                </div>
                <select value={ticket.status} onChange={(e) => updateStatus(ticket.id, e.target.value)} className="h-11 rounded-xl border px-3">
                  <option value="open">Open</option>
                  <option value="in_progress">In Progress</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
